import { createContext } from 'react';

const PbxContext = createContext();

export default PbxContext;
